
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { RadioGroup, InputGroup } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { ControlledField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Radio Group`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { RadioGroup } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ControlledField component={
  <RadioGroup
    options={[{
      label: 'Belgium',
      value: 'BE',
    }, {
      label: 'France',
      value: 'FR',
    }, {
      label: 'Italy',
      value: 'IT',
    }]} />
} />`} component={RadioGroup} mdxType="Playground">
  <ControlledField component={<RadioGroup options={[{
        label: 'Belgium',
        value: 'BE'
      }, {
        label: 'France',
        value: 'FR'
      }, {
        label: 'Italy',
        value: 'IT'
      }]} mdxType="RadioGroup" />} mdxType="ControlledField" />
</Playground>
<p>{`You can also disable individual options by adding `}<inlineCode parentName="p">{`disabled`}</inlineCode>{` to the options:`}</p>
<Playground __position={1} __code={`<ControlledField component={
  <RadioGroup
    options={[{
      label: 'Belgium',
      value: 'BE',
      disabled: true,
    }, {
      label: 'France',
      value: 'FR',
    }, {
      label: 'Italy',
      value: 'IT',
    }]} />
} />`} mdxType="Playground">
  <ControlledField component={<RadioGroup options={[{
        label: 'Belgium',
        value: 'BE',
        disabled: true
      }, {
        label: 'France',
        value: 'FR'
      }, {
        label: 'Italy',
        value: 'IT'
      }]} mdxType="RadioGroup" />} mdxType="ControlledField" />
</Playground>
<p>{`Not specifying an `}<inlineCode parentName="p">{`onChange`}</inlineCode>{` function will render the component `}<inlineCode parentName="p">{`read-only`}</inlineCode>{`:`}</p>
<Playground __position={2} __code={`<InputGroup>
  <RadioGroup
    options={[{
      label: 'Belgium',
      value: 'BE',
    }, {
      label: 'France',
      value: 'FR',
    }, {
      label: 'Italy',
      value: 'IT',
    }]} />
  <RadioGroup
    value="BE"
    options={[{
      label: 'Belgium',
      value: 'BE',
    }, {
      label: 'France',
      value: 'FR',
    }, {
      label: 'Italy',
      value: 'IT',
    }]} />
</InputGroup>`} mdxType="Playground">
  <InputGroup mdxType="InputGroup">
    <RadioGroup options={[{
          label: 'Belgium',
          value: 'BE'
        }, {
          label: 'France',
          value: 'FR'
        }, {
          label: 'Italy',
          value: 'IT'
        }]} mdxType="RadioGroup" />
    <RadioGroup value="BE" options={[{
          label: 'Belgium',
          value: 'BE'
        }, {
          label: 'France',
          value: 'FR'
        }, {
          label: 'Italy',
          value: 'IT'
        }]} mdxType="RadioGroup" />
  </InputGroup>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;